import { ChevronDown, Search } from './Icons'

type Props = {
  product: string
  channel: string
  status: string
  search: string
  products: string[]
  onProduct: (value: string) => void
  onChannel: (value: string) => void
  onStatus: (value: string) => void
  onSearch: (value: string) => void
}

function SelectControl({
  label,
  value,
  values,
  onChange,
}: {
  label: string
  value: string
  values: string[]
  onChange: (value: string) => void
}) {
  return (
    <label className="select-control">
      <span>{label}</span>
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {values.map((item) => (
          <option value={item} key={item}>
            {item}
          </option>
        ))}
      </select>
      <ChevronDown size={13} aria-hidden="true" />
    </label>
  )
}

export function Filters(props: Props) {
  return (
    <div className="filters">
      <SelectControl
        label="Product"
        value={props.product}
        values={['All', ...props.products]}
        onChange={props.onProduct}
      />
      <SelectControl
        label="Channel"
        value={props.channel}
        values={['All', 'Stable', 'Beta', 'Nightly', 'Internal']}
        onChange={props.onChannel}
      />
      <SelectControl
        label="Status"
        value={props.status}
        values={['All', 'Active', 'Suspended', 'Revoked', 'Expired']}
        onChange={props.onStatus}
      />
      <label className="table-search">
        <Search size={16} />
        <input
          value={props.search}
          onChange={(event) => props.onSearch(event.target.value)}
          placeholder="Email, purchase ID or license key"
          aria-label="Search entitlements"
        />
      </label>
    </div>
  )
}
